module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "voucher-view"
    }
  }, [_c('div', {
    attrs: {
      "id": "wideContent"
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "boxContent"
  }, [_c('h1', [_vm._v("Dárkové poukazy")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', [_vm._v("\n            Poukaz umožňuje využít veškerých salonem nabízených služeb, a to až do výše částky uvedené na dárkovém poukazu.\n            V případě, že celková cena využitých služeb přesáhne hodnotu poukazu, je možné zbývající částku uhradit při návštěvě salonu.\n            Poukaz má platnost po dobu čtyř měsíců ode dne zakoupení a je nutné se objednat alespoň 3 dny předem.\n            Poukazy jsou prodávány celoročně a je tedy možné je využít k nejrůznějším příležitostem.\n          ")]), _vm._v(" "), _c('a', {
    staticClass: "fancybox",
    attrs: {
      "href": require('../../../static/photos/voucher/voucher-preview.jpg'),
      "title": "Dárkový poukaz"
    }
  }, [_c('img', {
    staticStyle: {
      "border": "1px solid #D75974"
    },
    attrs: {
      "src": require("../../../static/photos/voucher/thumb_voucher-preview.jpg"),
      "width": "460px"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "cleaner"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            Psí salon Jája zavedl prodej Dárkových poukazů, kterými můžete obdarovat své zvířecí kamarády, např. jako "), _c('b', [_vm._v("dárek k Vánocům")]), _vm._v(".\n\t\t\t\t\t")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-69b8fc5a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/VoucherView.vue
// module id = 80
// module chunks = 0